import { Checkbox } from "antd";

import "./index.css";

function History(props) {
  const numberOfDays = props.numberOfDays;

  const days = [];
  for (let i = 0; i < numberOfDays; i++) {
    if (props.repeatUnit === "day" && i % props.repeatStep !== 0) continue;
    if (props.repeatUnit === "week" && parseInt(i / 7) % props.repeatStep !== 0) continue;
    days.push(props.startFrom.add(i, "day"));
  }

  const dateFormat = props.showWeekdays ? `${props.dateFormat} (${props.weekdayFormat})` : `${props.dateFormat}`;

  return (
    <div className="History">
      <div className="Tip">Tick checkboxes when done.</div>
      {days.map((day, rowIndex) => (
        <Checkbox.Group
          key={rowIndex}
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
          onChange={(value) => props.onHistoryUpdate(day, value)}
          value={props.history[day.format(dateFormat)]}
        >
          <div className="row">
            <div className="date">{day.format(dateFormat)}</div>
            {props.slotNames.map((name, slotIndex) => (
              <div key={`${rowIndex}-${slotIndex}`}>
                <Checkbox value={name}>{name.charAt(0).toUpperCase() + name.slice(1)}</Checkbox>
              </div>
            ))}
          </div>
        </Checkbox.Group>
      ))}
    </div>
  );
}

export default History;
